import React from 'react';
import { Card } from '../ui/Card';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
type DepthChartProps = {
  data: {
    date: string;
    depth: number;
  }[];
};
export const DepthChart: React.FC<DepthChartProps> = ({
  data
}) => {
  return <Card className="h-64" data-id="element-238">
      <h3 className="font-semibold mb-4" data-id="element-239">Depth Progression</h3>
      <div className="h-52" data-id="element-240">
        <ResponsiveContainer width="100%" height="100%" data-id="element-241">
          <LineChart data={data} margin={{
          top: 5,
          right: 5,
          left: 5,
          bottom: 5
        }} data-id="element-242">
            <CartesianGrid strokeDasharray="3 3" data-id="element-243" />
            <XAxis dataKey="date" tick={{
            fontSize: 12
          }} data-id="element-244" />
            <YAxis tick={{
            fontSize: 12
          }} domain={[0, 'dataMax + 5']} label={{
            value: 'Depth (m)',
            angle: -90,
            position: 'insideLeft',
            style: {
              textAnchor: 'middle',
              fontSize: 12
            }
          }} reversed data-id="element-245" />
            <Tooltip formatter={value => [`${value}m`, 'Depth']} labelFormatter={label => `Date: ${label}`} data-id="element-246" />
            <Line type="monotone" dataKey="depth" stroke="#0066CC" activeDot={{
            r: 8
          }} strokeWidth={2} data-id="element-247" />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </Card>;
};